module.exports = __webpack_public_path__ + "img/3.d9ccd68f.jpg";